import * as React from "react";
import Tag from "../../../../generic/tag";
import { FTChipColorKeyComb, FTScrollStyle } from "../../ftConstants";
import SlideUpPopup from "../../../../generic/slideUpPopup";
import { EdLinkButton } from "../../../../generic/edButton";
import { IcommLimits } from "../../../../types/components/fundTransfer/ftTypes";
import { dateTimeFormat } from "../../../../service/dateTimeService";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IFtHistoryTblPayOutMobProps {
	data: Array<any>;
	lim: string | IcommLimits;
	asset: string; //acctype either EQ or CO
}

const FtHistoryTblPayOutMob: React.FC<IFtHistoryTblPayOutMobProps> = (props) => {
	// isAccordianOpen = if row is open then it stores rowIndex otherwise -1
	const [isPopupOpen, setIsPopupOpen] = React.useState<number>();

	return (
		<div className="ft_hist_table">
			<ul
				className={"ft_his_data " + (props.data.length > 0 ? "ftScrollCont" : "")}
				style={FTScrollStyle(props.data.length > 0 ? true : false)}
			>
				{props.data.map((row, index) => {
					const date = moment(dateTimeFormat(row.dt, " ")).format("DD MMM 'YYYY");
					const limit = typeof props.lim === "string" ? props.lim : parseFloat(props.lim.lmAvl) + parseFloat(props.lim.poAmt);

					return (
						<React.Fragment key={index}>
							{row.sts.toLowerCase() === "payout pending" ? (
								<li className="fl_pend_row" onClick={() => setIsPopupOpen(index)}>
									<div className="fl_pend_data">
										<div className="pending_sts">
											<i className="edel-icon-clock ft_clock"></i>Request Received
										</div>
										<div className="col date_time">
											<label className="tm">{moment(row.tm, ["h:mm A"]).format("HH:mm:ss")} </label>
											<label> {date}</label>
										</div>
									</div>
									<div className="fl_pend_data">
										<div className="col bank">{row.bnkName}</div>
										<div className="col amount">₹{toINR(row.trnsAmt)}</div>
									</div>
								</li>
							) : (
								<li className="ft_his_row" onClick={() => setIsPopupOpen(index)}>
									<div className="fl_his">
										<div className="fl_row1">
											<div className="col amount">₹{toINR(row.trnsAmt)}</div>
											<div className="col status">
												<Tag value={row.sts} color={FTChipColorKeyComb[row.sts.toLowerCase()]} />
											</div>
										</div>
										<div className="fl_row2">
											<div className="col date_time">
												{/* <label className="tm">{time} </label> */}
												<label> {date}</label>
											</div>
											<div className="col bank">{row.bnkName}</div>
										</div>
									</div>
								</li>
							)}
							{isPopupOpen === index && (
								<SlideUpPopup closePopup={() => setIsPopupOpen(undefined)}>
									<div className="ftHistory_pop_cont">
										<button className="cls" onClick={() => setIsPopupOpen(undefined)}>
											<i className="edel-icon-close"></i>
										</button>
										<div className="bank_amt_Sec ft_dtl_sec">
											<div className="col amt_sts">
												<div className="amount">
													<span>₹{toINR(row.trnsAmt)}</span>
												</div>
												{row.sts.toLowerCase() === "payout pending" ? (
													<div className="pending_sts">
														<i className="edel-icon-clock ft_clock"></i>
														<span className="ib vMid">Request Received</span>
													</div>
												) : (
													<div className="status">
														<Tag value={row.sts} shape="chip" color={FTChipColorKeyComb[row.sts.toLowerCase()]} />
													</div>
												)}
											</div>
											<div className="col bank">{row.bnkName}</div>
											<div className="col date_time">
												<label className="date"> {date}</label>
												<label className="fl_circle"></label>
												<label className="tm">{moment(row.tm, ["h:mm A"]).format("HH:mm:ss")} </label>
											</div>
										</div>
										<div className="acc_sec ft_dtl_sec">
											<div className="data_con">
												<label className="txt">Bank A/C</label>
												<label className="val">{row.bnkAccNo}</label>
											</div>
											<div className="data_con">
												<label className="txt">Ref No.</label>
												<label className="val">{row.instNo}</label>
											</div>
											{row.payMd && (
												<div className="data_con">
													<label className="txt">Mode</label>
													<label className="val">{row.payMd}</label>
												</div>
											)}
											{row.upi && (
												<div className="data_con">
													<label className="txt">UPI ID</label>
													<label className="val">{row.upi}</label>
												</div>
											)}
											{row.ldgrNm && (
												<div className="data_con">
													<label className="txt">Ledger</label>
													<label className="val">{row.ldgrNm}</label>
												</div>
											)}
										</div>
										<div className="remark_sec ft_dtl_sec">
											<label className="rmrk_tit">Remarks</label>
											<label className="rmrk_val">{row.rmk}</label>
											{row.sts.toLowerCase() === "payout pending" && (
												<div className=" cta_sec taCenter">
													<EdLinkButton
														value="Edit Amount"
														btnTyp="secondary"
														className="cta edit_amt mg-b15"
														LinkHref={
															"../../withdraw-funds/edit?edit=" +
															JSON.stringify({ ...row, lim: limit, accType: props.asset })
														}
													/>
													<EdLinkButton
														value="Cancel Transfer"
														btnTyp="secondary"
														className="cta"
														LinkHref={
															"../../withdraw-funds/cancel?cancel=" + JSON.stringify({ ...row, accType: props.asset })
														}
													/>
												</div>
											)}
										</div>
									</div>
								</SlideUpPopup>
							)}
						</React.Fragment>
					);
				})}
			</ul>
		</div>
	);
};

export default FtHistoryTblPayOutMob;
